module.exports = __webpack_public_path__ + "static/img/resource_plat.41cd344c.png";